/**
 * Returns id + data-testid for interactive elements so QA can select by either.
 * Prefer passing an existing semantic id (kebab-case).
 */
export type DataTestIdProp = {
  "data-testid"?: string;
};

export function testIdProps(id?: string | null): {
  id?: string;
  "data-testid"?: string;
} {
  if (!id) return {};
  return { id, "data-testid": id };
}

export function resolveTestId(
  id?: string | null,
  dataTestId?: string | null
): string | undefined {
  return dataTestId ?? id ?? undefined;
}
